import { defineStore } from 'pinia';

import {
  AutocompleteRepository,
  AcquirerResponse,
} from '@/repositories/generated';

type AcquirerAutocompleteStoreState = {
  acquirers: AcquirerResponse[];
  tenantId: string | undefined;
};

export const useAcquirerAutocompleteStore = defineStore('acquirerAutocomplete', {
  state: (): AcquirerAutocompleteStoreState => ({
    acquirers: [],
    tenantId: undefined,
  }),
  actions: {
    async getAcquirers(tenantId?: string) {
      // 一度取得したらキャッシュから取得
      // if (this.acquirers.length && this.tenantId === tenantId) {
      //   return this.acquirers;
      // }

      const res = await AutocompleteRepository.searchAcquirer({
        term: undefined,
        tenantId,
      });
      this.acquirers = res;
      return res;
    },
  },
});
